import React, { useCallback } from 'react';

import Modal from '../../shared/modals/modal.component';

import { Period } from '@common/schemas/periods';
import { TlsAccount } from '@common/schemas/tlsAccount';

type DeleteTLSAccountModalProps = {
  period: Period,
  entityToRemove: TlsAccount,
  hideModal: () => void,
  removeEntity: (entity: TlsAccount, options: { rowIndex: number }) => void,
  rowIndex: number,
  isVisible: boolean,
  isRemovingEntity: boolean,
}

const DeleteTLSAccountModal = ({
  period,
  entityToRemove,
  hideModal,
  removeEntity,
  rowIndex,
  isVisible,
  isRemovingEntity,
}: DeleteTLSAccountModalProps) => {
  const removeTLSAccount = useCallback(() => {
    removeEntity({ ...entityToRemove, periodName: period.name }, { rowIndex });
  }, [removeEntity, entityToRemove, period, rowIndex]);

  return (
    <Modal
      className="delete-tls-account-modal"
      dismissText="Cancel"
      submitText="Yes"
      title="Delete Connection"
      closeAction={hideModal}
      dismissAction={hideModal}
      submitAction={removeTLSAccount}
      isVisible={isVisible}
      isSubmitting={isRemovingEntity}
    >
      { entityToRemove
        ? (
          <div>
            Are you sure you want to delete: <br/><br/>
            TLS Account: {entityToRemove.account}<br/>
            Period: {period.name}<br/><br/>
          </div>
        )
        : null
      }
    </Modal>
  );
};


export default DeleteTLSAccountModal;
